import { BRAND_POSTS } from "./brandPostsQuery.js";

export default {
  props: ["brandId", "banner"],

  data() {
    return {
      data: {
        edges: [],
      },
      limit: 4,
    };
  },

  mounted() {
    this.getPosts();
  },

  methods: {
    getPosts,
  },
};

async function getPosts() {
  const variables = {
    filters: {
      brandId: this.brandId,
    },
  };

  variables.first = this.limit;
  variables.after = "";
  variables.before = "";
  variables.cursor = "";

  // eslint-disable-next-line one-var
  const { data } = await this.$apollo.query({
    query: BRAND_POSTS,
    errorPolicy: "all",
    variables: variables,
  });

  this.data = data.posts;
}
